import { SignUp } from '@clerk/react';
import { useLocation } from 'react-router-dom';

import AuthLayout from '@/component-library/layouts/AuthLayout/AuthLayout';
import ClerkChooseOrganizationTask from '@/component-library/widgets/ClerkChooseOrganizationTask/ClerkChooseOrganizationTask';
import PathBOrgConfirmGate from '@/component-library/widgets/PathBOrgConfirmGate/PathBOrgConfirmGate';
import { isClerkChooseOrganizationTaskPath } from '@/utils/auth/clerkAuthPaths';
import { isPathBCustomOrgConfirmEnabled } from '@/utils/auth/pathBOrgConfirm';

/**
 * Do not set fallbackRedirectUrl to /dashboard or /sign-in/tasks/... —
 * wrong targets race or hang the choose-organization session task.
 * After OTP, Clerk navigates to /sign-up/tasks/choose-organization; we render
 * TaskChooseOrganization there explicitly.
 */
const ClerkSignUpPage = () => {
  const location = useLocation();

  if (isClerkChooseOrganizationTaskPath(location.pathname)) {
    return (
      <AuthLayout>
        <div className="flex w-full justify-center">
          <PathBOrgConfirmGate source="sign-up">
            <ClerkChooseOrganizationTask />
          </PathBOrgConfirmGate>
        </div>
      </AuthLayout>
    );
  }

  const signUp = <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />;

  return (
    <AuthLayout>
      <div className="flex w-full justify-center">
        {isPathBCustomOrgConfirmEnabled() ? (
          <PathBOrgConfirmGate source="sign-up">{signUp}</PathBOrgConfirmGate>
        ) : (
          signUp
        )}
      </div>
    </AuthLayout>
  );
};

export default ClerkSignUpPage;
